import { Image, ImageProps } from '@chakra-ui/react';
import * as React from 'react';

import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

export const GridImage: React.FC<ImageProps> = ({ ...imageProps }) => {
  return (
    <Image
      fit="cover"
      width="100%"
      height="100%"
      _hover={{ cursor: 'pointer' }}
      alt=""
      fallback={
        <ImageFallback w="full" h="full" opacity={imageProps.opacity} />
      }
      {...imageProps}
    />
  );
};
